import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField } from '@material-ui/core';
import { setPartialFilters } from '@actions/lettersPageActions';
import { translate } from '@utils';
import { MgState, SubmissionQueryInterface } from '@types';
import '../index.scss';
import { useDebounce } from '@hooks/useDebounce';

const SearchTextField = () => {
  const dispatch = useDispatch();
  const { title } = useSelector<MgState, SubmissionQueryInterface>(
    ({ lettersPage }) => lettersPage.filters
  );
  const [searchValue, setSearchValue] = useState<string>(title);
  const debouncedTitle = useDebounce<string>(searchValue, 500);

  useEffect(() => {
    setSearchValue(title);
  }, [title]);

  useEffect(() => {
    if (debouncedTitle !== title) {
      dispatch(setPartialFilters({ title: debouncedTitle }));
    }
  }, [debouncedTitle, dispatch]);

  return (
    <TextField
      value={searchValue}
      data-testid="filter-search-text-field"
      variant="outlined"
      className="filter-search-text-field"
      placeholder={translate('search')}
      onChange={({ currentTarget }) => setSearchValue(currentTarget.value)}
    />
  );
};

export { SearchTextField };
